// Traductions du mode Lite : page « accounts ».
export const fr = {
  title: "Comptes",
  subtitle: "Où en est chaque compte, et combien ils te rapportent.",
  addAccount: "Ajouter un compte",
  connectTradovate: "Connecter Tradovate",
  summary: {
    active: "Comptes actifs",
    inactiveHint: (n: number) => `${n} inactif${n > 1 ? "s" : ""}`,
    spent: "Dépensé en prop firms",
    spentHint: "Challenges, activations et frais",
    payouts: "Payouts reçus",
    balance: "Bilan",
    balanceHint: "Payouts moins dépenses",
  },
  show: {
    active: (n: number) => `Actifs (${n})`,
    inactive: (n: number) => `Inactifs (${n})`,
    all: (n: number) => `Tous (${n})`,
  },
  disconnect: {
    title: (firm: string) => `Déconnecter ${firm} ?`,
    text: "La synchronisation automatique de ses comptes s'arrête. Tes trades déjà importés sont conservés, et tu pourras reconnecter la prop firm à tout moment.",
  },
  demo: {
    reconnectTitle: "Redirection vers Tradovate",
    reconnectText: "En vrai, tu serais redirigé vers Tradovate pour ré-autoriser la connexion. Démo : rien ne se passe.",
    disconnectTitle: "Connexion déconnectée",
    noAction: "Démo : aucune action réelle.",
  },
  personalGroup: "Sans prop firm",
  groupCount: (n: number) => `${n} compte${n > 1 ? "s" : ""}`,
  noneHere: "Aucun compte ici",
  noneHereText: "Change de filtre pour en voir d'autres.",
  empty: {
    title: "Aucun compte pour l'instant",
    text: "Un compte = une prop firm (challenge ou funded) ou ton compte perso. Ses règles sont pré-remplies selon la prop firm.",
  },
  hidden: {
    text: (n: number) => `${n} compte${n > 1 ? "s" : ""} masqué${n > 1 ? "s" : ""} : le plan Free n'affiche que ton compte le plus récent.`,
    cta: "Voir les plans",
  },
};

export const en: typeof fr = {
  title: "Accounts",
  subtitle: "Where each account stands, and how much they bring in.",
  addAccount: "Add an account",
  connectTradovate: "Connect Tradovate",
  summary: {
    active: "Active accounts",
    inactiveHint: (n: number) => `${n} inactive`,
    spent: "Spent on prop firms",
    spentHint: "Challenges, activations and fees",
    payouts: "Payouts received",
    balance: "Net",
    balanceHint: "Payouts minus expenses",
  },
  show: {
    active: (n: number) => `Active (${n})`,
    inactive: (n: number) => `Inactive (${n})`,
    all: (n: number) => `All (${n})`,
  },
  disconnect: {
    title: (firm: string) => `Disconnect ${firm}?`,
    text: "Automatic sync of its accounts stops. Trades already imported are kept, and you can reconnect the prop firm at any time.",
  },
  demo: {
    reconnectTitle: "Redirecting to Tradovate",
    reconnectText: "For real, you would be sent to Tradovate to re-authorize the connection. Demo: nothing happens.",
    disconnectTitle: "Connection disconnected",
    noAction: "Demo: no real action.",
  },
  personalGroup: "No prop firm",
  groupCount: (n: number) => `${n} account${n > 1 ? "s" : ""}`,
  noneHere: "No account here",
  noneHereText: "Change the filter to see others.",
  empty: {
    title: "No account yet",
    text: "An account is a prop firm account (challenge or funded) or your personal account. Its rules are pre-filled from the prop firm.",
  },
  hidden: {
    text: (n: number) => `${n} account${n > 1 ? "s" : ""} hidden: the Free plan only shows your most recent account.`,
    cta: "See plans",
  },
};
